import { siteConfig } from 'lemans-brandsites-common/libs/config';
import * as React from 'react';
import 'theme/components/Image/Image.styles.less';
import { IImageProps } from "./Image.types";

export const Image = (props:IImageProps) => 
    <img 
        src={props.src && (props.src.startsWith('http://') || props.src.startsWith('https://')) 
            ? props.src 
            : `${siteConfig.imageBase}${props.src}`
        } 
        title={props.title} 
    />;